import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, ModalController, Modal } from 'ionic-angular';
import { iConfiguracion } from '../../models/basePage';
import { APIOnLine } from '../../services/api/api.services';
import { pouchdb2 } from '../../services/pouchdb/pouchdb.service';
import { ResultadoPage } from '../resultado/resultado';
import { ModalActivarAlineacionesPage } from '../modal-activar-alineaciones/modal-activar-alineaciones';
import * as moment from 'moment';
import { FinalizarPage } from '../finalizar/finalizar';
import { Proxy } from '../../services/proxy/proxy.service';
import { AlineacionPage } from '../alineacion/alineacion';
import { PaginaBasica } from '../../models/PaginaBase';
import { AsistentesPage } from '../asistentes/asistentes';
import { Online } from '../../models/online/cfutbol';
import { DeclaracionesPage } from '../declaraciones/declaraciones';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage extends PaginaBasica {
  // #region Propiedades del controlador
  public desig: Proxy.PrDesignaciones;
  public designaciones: Array<Proxy.PrDesignaciones> = [];
  public configuraciones: iConfiguracion;
  public tieneMensajesSinLeer: boolean = false;

  private _fechaMaxima: string = moment().add(10, 'year').format('DD/MM/YYYY');
  // #endregion

  constructor(
    public navCtrl: NavController,
    public DBService2: pouchdb2.DBService2,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public modalCtrl: ModalController,
    public CFutbolActas: APIOnLine.CFutbolActas,
    public DeclaracionesCOVIDDesignacionService: APIOnLine.DeclaracionesCOVIDDesignacionService,
    public Persistentes: APIOnLine.Persistentes
  ) {
    super(loadingCtrl, toastCtrl);
    this.desig = new Proxy.PrDesignaciones(this.CFutbolActas, this.DBService2, this.Persistentes);
  }

  ionViewDidEnter() {
    this.MostrarOcultarCarga();
    this.designaciones = [];
    this.Persistentes
      .GetConfiguracion()
      .then((resultado: iConfiguracion) => {
        this.configuraciones = resultado;
        // Obtención de la lista de designaciones del usuario actual
        return this.desig.DesignacionesPorUsuario(this.Persistentes.GetArbitro().idArbitro);
      })
      .then((resultado: Array<Proxy.PrDesignaciones>) => {
        this.designaciones = resultado;
        console.log(resultado);

        return this.CFutbolActas.tieneMensajesObligatoriosSinLeer(this.Persistentes.GetArbitro().idArbitro);
      })
      .then((resultado: boolean) => {
        console.log('Tiene mensajes obligatorios sin leer: ' + resultado);
        this.tieneMensajesSinLeer = resultado;
        this.MostrarOcultarCarga();
      })
      .catch((error) => this.Error(error, 'Obteniendo designaciones por usuario'));
  }

  // #region Métodos del controlador

  /**
   * El usuario ha seleccionado la opción de 'Alineaciones' para una designación. Hay que comprobar si tiene las alineaciones terminadas, para presentar la ventana modal que permita indicar una razón para volver a activar esa zona
   * @param designacion Datos de la designación a la que se quiere acceder
   */
  public Alineaciones(designacion: Proxy.PrDesignaciones): void {
    if (designacion.OtrosDatos.alineacionesTerminadas) {
      let modal: Modal = this.modalCtrl.create(ModalActivarAlineacionesPage);
      modal.onDidDismiss((data) => {
        if (data != undefined) {
          designacion.OtrosDatos.reactivaciones +=
            '<p>A las <b>' +
            moment().format('DD/MM/YYYY HH:mm') +
            '</b> se han vuelto a activar las alineaciones debido a:<br/>' +
            data +
            '</p>';

          this.MostrarOcultarCarga();

          // Configuración de las direcciones de la API en OtrosDatos. Es necesario para que se guarde correctamente la información.
          designacion.OtrosDatos.urlApi = designacion.urlApi;
          designacion.OtrosDatos.urlNombre = designacion.urlNombre;

          designacion.OtrosDatos
            .Guardar()
            .then((resultado: boolean) => {
              this.MostrarOcultarCarga();

              this.Persistentes.SetDesignacion(designacion, designacion.idLocal);
              this.navCtrl.push(AlineacionPage);
            })
            .catch((error) =>
              this.Error(
                JSON.stringify(error),
                'ERROR: Activando las alineaciones de la designación: ' + designacion.idDesignacion
              )
            );
        }
      });
      modal.present();
    } else {
      //! Importante. Aquí se comprueba si la configuración 'declaracionesCOVID' está activada, para presentar la pantalla con el formulario de las declaraciones
      if (
        this.configuraciones.internas.declaracionesCOVID != null &&
        this.configuraciones.internas.declaracionesCOVID == true
      ) {
        this.ComprobarDeclaraciones(designacion, 'Alineacion');
      } else {
        this.Persistentes.SetDesignacion(designacion, designacion.idLocal);
        this.navCtrl.push(AlineacionPage);
      }
    }
  }

  /**
   * Va a la página de los asistentes relacionados con la designación
   * @param designacion Datos de la designación seleccionada
   */
  public Asistentes(designacion: Proxy.PrDesignaciones): void {
    this.Persistentes.SetDesignacion(designacion, designacion.idLocal);
    this.navCtrl.push(AsistentesPage);
  }

  public CadenaHorasProximoEncuentro(): string {
    let resultado: string = '';
    let hayDesignacionPosterior: boolean = false;
    let plantilla: string =
      "<h2>Tu próximo partido es en</h2><h3><span class='big'><!--Dias--></span> <span class='small'>días</span> y <span class='big'><!--Horas--></span> <span class='small'>horas</span></h3>";
    let plantillaSinDias: string =
      "<h2>Tu próximo partido es en</h2><h3><span class='big'><!--Horas--></span> <span class='small'>horas</span></h3>";

    if (this.designaciones != null && this.designaciones.length > 0) {
      this.designaciones.forEach((valor: Proxy.PrDesignaciones) => {
        let fechaDesignacion: moment.Moment = moment(valor.fecha + ' ' + valor.hora, 'DD/MM/YYYY HH:mm');

        if (fechaDesignacion.toDate() > moment().toDate()) {
          hayDesignacionPosterior = true;
        }
      });
    }

    if (hayDesignacionPosterior) {
      if (this.DiasProximoEncuentro() > 0) {
        resultado = plantilla
          .replace('<!--Dias-->', this.DiasProximoEncuentro().toString())
          .replace('<!--Horas-->', this.HorasProximoEncuentro().toString());
      } else {
        resultado = plantillaSinDias.replace('<!--Horas-->', this.HorasProximoEncuentro().toString());
      }
    } else {
      resultado = '<h2>No tienes partidos pendientes</h2>';
    }

    return resultado;
  }

  private ComprobarDeclaraciones(designacion: Proxy.PrDesignaciones, pagina: string): void {
    // Carga de la información de las declaraciones por Designación
    this.MostrarOcultarCarga();
    this.DeclaracionesCOVIDDesignacionService
      .porDesignacion(designacion.idDesignacion, designacion.urlApi)
      .then((declaraciones: Online.DeclaracionesCOVIDDesignacion[]) => {
        // Se comprueba si no se han guardado las declaraciones, para ponder como "undefined" los valores de "cercania" y "sintomas"
        declaraciones = declaraciones.map((m) => {
          if (m.id == 0) {
            m.cercania = undefined;
            m.sintomas = undefined;
          }
          return m;
        });

        // Se comprueba que no se haya notificado ningún positivo
        if (
          declaraciones != null &&
          declaraciones.length > 0 &&
          declaraciones.filter((m) => m.cercania || m.sintomas).length > 0
        ) {
          designacion.bloqueada = true;
          this.designaciones = this.designaciones.map((m) => {
            if (m.idDesignacion == designacion.idDesignacion) {
              return designacion;
            } else {
              return m;
            }
          });

          this.Mensaje(
            'Esta declaración ha sido bloqueada porque se ha informado de un contacto o síntoma COVID-19',
            6000
          );
        } else {
          this.Persistentes.SetDesignacion(designacion, designacion.idLocal);
          if (declaraciones != null && declaraciones.filter((m) => m.id == 0).length > 0) {
            // Hay colegiados que no han realizado su declaración
            this.Persistentes.SetDeclaraciones(declaraciones);
            this.navCtrl.push(DeclaracionesPage, {
              pagina: pagina
            });
          } else {
            switch (pagina) {
              case 'Alineacion':
                this.navCtrl.push(AlineacionPage);
                break;
              case 'Finalizar':
                this.navCtrl.push(FinalizarPage, {
                  idDesignacion: designacion.idDesignacion
                });
                break;
              case 'Resultado':
                this.navCtrl.push(ResultadoPage, {
                  idDesignacion: designacion.idDesignacion
                });
                break;
            }
          }
        }
        this.MostrarOcultarCarga();
      })
      .catch((error) =>
        this.Error(JSON.stringify(error), 'ERROR: Obteniendo la información de las Declaraciones COVID')
      );
  }

  public DiasProximoEncuentro(): number {
    let resultado: number = 0;

    if (this.designaciones && this.designaciones.length > 0) {
      let fecha: moment.Moment = moment(this._fechaMaxima, 'DD/MM/YYYY');
      let ahora: moment.Moment = moment();

      this.designaciones.forEach((valor: Proxy.PrDesignaciones) => {
        let fechaDesignacion: moment.Moment = moment(valor.fecha + ' ' + valor.hora, 'DD/MM/YYYY HH:mm');

        if (fechaDesignacion.toDate() >= moment().toDate() && fechaDesignacion.toDate() < fecha.toDate()) {
          fecha = fechaDesignacion;
        }
      });
      resultado = fecha.diff(ahora, 'days');
    }

    return resultado;
  }

  public HorasProximoEncuentro(): number {
    let resultado: number = 0;

    if (this.designaciones && this.designaciones.length > 0) {
      let fecha: moment.Moment = moment(this._fechaMaxima, 'DD/MM/YYYY');
      let ahora: moment.Moment = moment();
      this.designaciones.forEach((valor: Proxy.PrDesignaciones) => {
        let fechaDesignacion: moment.Moment = moment(valor.fecha + ' ' + valor.hora, 'DD/MM/YYYY HH:mm');

        if (fechaDesignacion.toDate() >= moment().toDate() && fechaDesignacion.toDate() < fecha.toDate()) {
          fecha = fechaDesignacion;
        }
      });
      var totalHoras = fecha.diff(ahora, 'hours');
      resultado = totalHoras % 24;
    }

    return resultado;
  }

  public Resultado(designacion: Proxy.PrDesignaciones): void {
    //! Importante. Aquí se comprueba si la configuración 'declaracionesCOVID' está activada, para presentar la pantalla con el formulario de las declaraciones
    if (
      this.configuraciones.internas.declaracionesCOVID != null &&
      this.configuraciones.internas.declaracionesCOVID == true
    ) {
      if (designacion.OtrosDatos.actaCerrada) {
        this.ComprobarDeclaraciones(designacion, 'Finalizar');
      } else {
        this.ComprobarDeclaraciones(designacion, 'Resultado');
      }
    } else {
      this.Persistentes.SetDesignacion(designacion);
      this.Persistentes.SetIdEquipo(designacion.idLocal);
      if (designacion.OtrosDatos.actaCerrada) {
        this.navCtrl.push(FinalizarPage, {
          idDesignacion: designacion.idDesignacion
        });
      } else {
        this.navCtrl.push(ResultadoPage, {
          idDesignacion: designacion.idDesignacion
        });
      }
    }
  }

  // #endregion
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts